module.exports = __webpack_public_path__ + "static/media/burger-menu.7ea0dc82.svg";